import { ActionIcon, useMantineColorScheme, useComputedColorScheme, Tooltip } from '@mantine/core'
import { FC } from 'react'
import { TbMoonStars, TbSunHigh } from 'react-icons/tb'
import { useTranslation } from 'react-i18next'

const ThemeToggle: FC = () => {
  const { setColorScheme } = useMantineColorScheme()
  const computedColorScheme = useComputedColorScheme('light')
  const isDark = computedColorScheme === 'dark'
  const { t } = useTranslation('common')
  const tooltipLabel = isDark ? t('switchToLightMode') : t('switchToDarkMode')

  return (
    <Tooltip label={tooltipLabel} withArrow>
      <ActionIcon
        variant="subtle"
        size="lg"
        color="gray"
        onClick={() => setColorScheme(isDark ? 'light' : 'dark')}
        aria-label={tooltipLabel}
      >
        {isDark ? <TbSunHigh size={18} /> : <TbMoonStars size={18} />}
      </ActionIcon>
    </Tooltip>
  )
}

export default ThemeToggle
